<common-mojo-card>
  <div class="charts-container">
    <div class="left-section">
      <div class="pipeline-card">
        <div class="pipeline-card-label">ACTIVE JOBS</div>
        <div class="pipeline-card-number">{{ activeJobCount$ | async }}</div>
      </div>
      <div class="pipeline-card">
        <div class="pipeline-card-label">TOTAL APPLICANTS</div>
        <div class="pipeline-card-number">{{ totalApplicants$ | async }}</div>
        <div class="pipeline-card-matches-numbers">
          <mojo-pipeline-total-matches-numbers
            [aggregatedJobData]="aggregatedJobData$ | async"
          >
          </mojo-pipeline-total-matches-numbers>
        </div>
      </div>
    </div>
    <div class="chart-section">
      <div class="pipeline-card-label shortlist-status">
        SHORTLIST STATUS
      </div>
      <div
        *ngIf="barChartData$ | async as barChartData"
        class="bar-charts"
      >
        <common-mojo-bar-chart [barChartData]="barChartData">
        </common-mojo-bar-chart>
      </div>
    </div>
  </div>
</common-mojo-card>
